import Icon from '@ant-design/icons'
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon'
import { forwardRef } from 'react'
import { AntdCustomIconComponentProps } from '../typings/AntdCustomIconComponentProps'

const ArrowUpSquareSvg = (props: AntdCustomIconComponentProps) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.666 20.5C5.136 20.5 3.5 18.767 3.5 16.084V7.916C3.5 5.233 5.136 3.5 7.666 3.5H16.335C18.865 3.5 20.5 5.233 20.5 7.916V16.084C20.5 18.767 18.865 20.5 16.335 20.5H7.666ZM16.335 2H7.666C4.277 2 2 4.378 2 7.916V16.084C2 19.622 4.277 22 7.666 22H16.335C19.724 22 22 19.622 22 16.084V7.916C22 4.378 19.724 2 16.335 2ZM11.25 9.72932L8.78295 12.2071C8.49095 12.5021 8.01695 12.5001 7.72295 12.2091C7.42995 11.9171 7.42795 11.4421 7.72095 11.1481L11.469 7.38411C11.6089 7.24211 11.801 7.16311 12 7.16311C12.1989 7.16311 12.3909 7.24211 12.5309 7.38411L16.2789 11.1481C16.5719 11.4421 16.57 11.9171 16.2769 12.2091C15.9839 12.5001 15.5099 12.5021 15.2169 12.2071L12.75 9.72942V16.0861C12.75 16.5001 12.414 16.8361 12 16.8361C11.586 16.8361 11.25 16.5001 11.25 16.0861V9.72932Z"
    />
  </svg>
)

export const ArrowUpSquare = forwardRef<HTMLSpanElement, AntdIconProps>(
  (props, ref) => <Icon component={ArrowUpSquareSvg} {...props} ref={ref} />
)
